<style lang="stylus">
    @keyframes notifyin {
        0% {
            opacity 0
            transform translateX(-50%) translateY(-100%)
        }
        30%{
            opacity .7
            transform translateX(-50%) translateY(0)
        }
        100%{
            opacity 1
            transform translateX(-50%) translateY(0)
        }
    }
    @keyframes notifyout {
        0% {
            opacity 1
            transform translateX(-50%) translateY(0)
        }
        100%{
            display none
            opacity 0
            transform translateX(-50%) translateY(0)
        }
    }
    @keyframes notifyrotate {
        0% {
            transform rotate(0)
        }
        100%{
            transform rotate(360deg)
        }
    }
    .notifyBox
        position fixed
        display none
        align-items center
        opacity 0
        left 50%
        transform translateX(-50%)
        width auto
        padding 8px 16px
        z-index 23333
        &.notifyBoxWithProgress
            flex-direction column;
        &.notify-box-with-extra-btn
            padding 12px 16px;
            border-radius 8px;
            p
                margin-right 12px;
                white-space nowrap
            .extra-btn
                display flex;
                z-index 1
                .btn
                    cursor pointer
                    color: #fff;
                    background-color rgba(255, 255, 255, 0.08);
                    border: 1px solid rgba(255, 255, 255, 0.1)
                    padding 0 12px;
                    font-size 12px
                    height 24px;
                    line-height 22px;
                    border-radius 4px;
                    &.ok
                        line-height 24px;
                        margin-right 8px;
                        border none;
                        background-color var(--themeColor)
                    &.cancel
                        display flex;
        .notifyBox-bg
            position absolute
            left 0
            top 0
            width 100%
            height 100%
            border-radius 8px
            background var(--bg-color-tips)
            border 0.5px solid rgba(0, 0, 0, 0.05)
            backdrop-filter blur(2px)

        img
            width 24px
            height 24px
            margin-right 8px
            z-index 1
            &.loading-img
                animation notifyrotate 1s linear infinite
        p
            float left
            font-size 14px
            line-height 18px
            color #fff
            z-index 1
        .notifyBox-progress-text
            margin-bottom 6px;
            font-size 14px
            line-height 18px
            color #fff
            z-index 1
    .notifyBox.notifyin
        display flex
        animation: notifyin .8s linear forwards
    .notifyBox.notifyout
        display flex
        animation: notifyout .2s linear forwards
</style>

<template>
    <div ref="notifyBox" class="notifyBox" :style="`top: ${top}px`">
        <template v-if="imgType === 6">
            <div class="notifyBox-bg"></div>
            <div class="notifyBox-progress-text" v-html="notifyBoxText"></div>
            <ProgressBar class="notifyBox-progress-bar" ref="progressBar" />
        </template>
        <template v-else-if="imgType === 7">
            <div class="notifyBox-bg"></div>
            <p v-html="notifyBoxText"></p>
            <div class="extra-btn">
                <div class="btn ok" @click="handleExtraOk">{{ extraOkText }}</div>
                <div class="btn cancel" @click="handleExtraCancel">
                    <span>{{ extraCancelText }}</span>
                    <CountDown v-if="duration !== undefined" :duration="duration" @countDown="handleCountDown" />
                </div>
            </div>
        </template>
        <template v-else-if="imgType !== -1">
            <div class="notifyBox-bg"></div>
            <img v-show="imgType == 1" :src="require('./message-succ.svg')" alt="" />
            <img v-show="imgType == 2" :src="require('./message-error.svg')" alt="" />
            <img v-show="imgType == 3" :src="require('./message-warn.svg')" alt="" />
            <img class="loading-img" v-show="imgType == 5" :src="require('./message-loading.svg')" alt="" />
            <p v-html="notifyBoxText"></p>
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import ProgressBar from "../ProgressBar/ProgressBar.vue";
    import CountDown from "./CountDown.vue";

    @Component({
        components: {
            ProgressBar,
            CountDown,
        },
    })
    export default class EDMessage extends Vue {
        notifyBoxText = "asd";
        imgType = 0;
        timer = 0;
        top = 30;
        options;
        extraOkText;
        extraCancelText;
        duration;

        showNotify(str, time, type) {
            // 提示消息
            const ts: any = this;
            var t = this.$refs.notifyBox as HTMLElement;
            this.imgType = type;
            this.notifyBoxText = str;
            clearTimeout(this.timer);
            t.classList.add("notifyin");
            t.classList.remove("notifyout");
            if (time > 0) {
                this.timer = setTimeout(() => {
                    t.classList.remove("notifyin");
                    t.classList.add("notifyout");
                    ts.$removeDom();
                }, time);
            }
        }
        removeNotify() {
            const ts: any = this;
            clearTimeout(this.timer);
            var t = this.$refs.notifyBox as HTMLElement;
            t.classList.remove("notifyin");
            // t.classList.add('notifyout');
            ts.$removeDom();
        }

        loadingNotify(str, time, type) {
            this.showNotify(str, time, type);
            return this.removeNotify;
        }

        removeNotifyBar() {
            const ts: any = this;
            setTimeout(() => {
                this.imgType = -1;
                const ele = this.$refs.notifyBox as HTMLElement;
                ele.classList.remove("notifyin");
                ele.classList.add("notifyout");
            }, 120);
            ts.$removeDom(1000);
        }

        loadingNotifyWithBar(str, time, type) {
            const ele = this.$refs.notifyBox as HTMLElement;
            ele.classList.add("notifyBoxWithProgress");
            this.showNotify(str, time, type);
            return {
                remove: this.removeNotifyBar,
                instance: this,
            };
        }

        showInfoWithExtra(opt, type) {
            this.options = opt;
            this.extraOkText = opt.okText;
            this.extraCancelText = opt.cancelText;
            this.duration = opt.duration;
            const ele = this.$refs.notifyBox as HTMLElement;
            ele.classList.add("notify-box-with-extra-btn");
            this.showNotify(opt.content, 0, type);
        }

        handleCountDown() {
            this.imgType = -1;
            this.options?.onCountDown();
        }

        handleExtraOk() {
            this.options?.onOk();
            this.imgType = -1;
        }

        handleExtraCancel() {
            this.options?.onCancel();
            this.imgType = -1;
        }

        config(options) {
            if (options.top || options.top === 0) {
                this.top = options.top;
            }
        }

        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
